import { Box, CircularProgress, Modal, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

//local imports
import AdxFullWindowTitleBar from 'components/reusable/fullWindowTitleBar/AdxFullWindowTitleBar'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import useOpenClose from 'services/hooks/useOpenClose'
import JobAdForm from 'module/recruitment/pages/recruitment-create-job-ad/components/JobAdForm/JobAdForm'
import AdxPopper from 'components/reusable/AdxPopper'
import { useState } from 'react'
import { deleteJobAds } from 'services/api/modules/recruitment/job-advertisment'
import { useMutation, useQueryClient } from 'react-query'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import ViewJobLink from '../../recruitment-manage-applicant/components/ViewJobLink'
import AdxButton from 'components/custom/AdxButton'

const ADNEXIO_JOBS_URL = process.env.REACT_APP_ADNEXIO_JOBS_URL

const JobAdWindow = ({
  initialValues,
  onSubmit,
  handleTypeOfForm,
  handleUpdateJobAds,
  createJobPostingPublishIsSuccess,
  createJobPostingPublishisLoading,
  createJobPostingDraftisLoading,
  formTitle,
  editJobAds = false,
  publishJobAds = false,
  editIsLoading,
  draftIsLoading,
}) => {
  const navigate = useNavigate()

  const jobBoardUrl = `${window.location.origin}/job-board/${initialValues?.company_name}/${initialValues?.tenant_identifier}/${initialValues?.id}`
  const adnexioJobsUrl = ADNEXIO_JOBS_URL

  // close job ad
  const confirmationModal = useOpenClose(false)

  // delete Modal
  const deleteModal = useOpenClose(false)
  const deleteSucess = useOpenClose(false)
  const errorSnackbar = useOpenClose(false)

  //set value for save job ads
  const [formikValues, setFormikValues] = useState(null)
  const handleFormikValues = (data) => {
    setFormikValues(data)
  }

  //preview job ad drawer
  const [drawerState, setDrawerState] = useState({ right: false })
  const handleDrawer = (anchor, open) => (event) => {
    setDrawerState({ ...drawerState, [anchor]: open })
  }

  // success job ads
  const successAdModal = useOpenClose(false)

  const handleSave = (formikValues) => {
    handleUpdateJobAds(formikValues)
    if (initialValues?.advertisement_status === 1) {
      successAdModal.handleOpen()
    }
  }

  const handleModalClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      successAdModal.handleClose()
    }
  }

  // fail job ads
  const failAdModal = useOpenClose(true)

  // loading job ads
  const loadingAdModal = useOpenClose(true)

  // API CALL
  const queryClient = useQueryClient()
  const {
    isLoading: deleteLoading,
    isSuccess: deleteIsSuccess,
    error: deleteError,
    mutate: deleteMutate,
  } = useMutation((id) => deleteJobAds(id), {
    onSuccess: async () => {
      queryClient.resetQueries('getAllJobAds')
      queryClient.invalidateQueries('getAllJobAds')
      deleteSucess.handleOpen()
      publishJobAds ? navigate(-1) : navigate('/app/recruitment/dashboard')
    },
    onError: async (error) => {
      queryClient.invalidateQueries('getAllJobAds')
      errorSnackbar.handleOpen()
    },
  })

  //close job ad component modal
  const CloseJobAdConfirmationModal = () => (
    <AdxInfoModal
      variant="standard"
      open={confirmationModal.isOpen}
      onClose={confirmationModal.handleClose}
      muiIcon="error_icon"
      iconColor="alternate.main"
      title="Unsaved changes"
      subtitle="Do you want to save your changes before leaving?"
      footerButtons
      firstBtnLabel={'Save Changes'}
      firstBtnHandle={() => {
        handleSave(formikValues)
        navigate('/app/recruitment')
      }}
      secondBtnLabel={'Discard Changes'}
      secondBtnHandle={() => navigate('/app/recruitment')}
    />
  )

  //success job ad modal component
  const SuccessJobAdsModal = () => {
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 550,
      bgcolor: 'background.paper',
      borderRadius: '6.5px',
      p: '32px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '32px',
    }
    return (
      <Modal
        open={
          (successAdModal.isOpen && initialValues?.advertisement_status !== 3) ||
          (createJobPostingPublishIsSuccess && initialValues?.advertisement_status !== 3)
        }
        onClose={handleModalClose}
        disableEscapeKeyDown
      >
        <Box sx={style}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Typography variant="h4" sx={{ color: 'dark-text.main' }}>
              {createJobPostingPublishIsSuccess && initialValues?.advertisement_status === 1
                ? 'Job successfully updated'
                : 'Your job ad has been published'}
            </Typography>
            <Typography sx={{ textAlign: 'center', color: 'light-gray-text.main' }}>
              Share the job posting with potential candidates and expand your search.
            </Typography>
          </Box>
          <ViewJobLink adnexioJobsUrl={adnexioJobsUrl} jobBoardUrl={jobBoardUrl} />
          <AdxButton variant={'outlined'} fullWidth onClick={() => navigate('/app/recruitment')}>
            Close
          </AdxButton>
        </Box>
      </Modal>
    )
  }

  //Delete job ad modal component
  const DeleteJobAdsModal = () => (
    <AdxInfoModal
      variant="error"
      open={deleteModal.isOpen}
      onClose={deleteModal.handleClose}
      muiIcon="error_icon"
      iconColor="error.main"
      title="Delete job advertisement?"
      subtitle="Are you sure you want to delete the job advertisement? Once deleted, you can no longer retrieve applicants data for this job advertisement"
      footerButtons
      firstBtnLabel={'Delete'}
      firstBtnHandle={() => {
        deleteMutate(initialValues?.id)
      }}
      secondBtnLabel={'Cancel'}
      secondBtnHandle={deleteModal.handleClose}
    />
  )

  //loading job ad modal component
  const LoadingJobAdsModal = () => (
    <AdxInfoModal
      open={loadingAdModal.isOpen}
      onClose={loadingAdModal.handleClose}
      muiIcon
      iconColor
      title={<CircularProgress color="alternate" />}
      subtitle
    />
  )

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        bgcolor: 'gray-background.main',
        width: 1,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* window title */}
      <AdxFullWindowTitleBar
        sx={{
          position: 'sticky',
          zIndex: 11,
          top: 0,
          left: 0,
        }}
        onClose={confirmationModal.handleOpen}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
          <Box display="flex" gap={2} alignItems="center">
            <Typography variant="h4">{formTitle}</Typography>
            {publishJobAds ? (
              <Typography
                variant="subtitle1"
                bgcolor="default-background.main"
                color="light-gray-text.main"
                px={1}
              >
                Draft
              </Typography>
            ) : null}
            {initialValues?.advertisement_status === 1 ? (
              <Typography
                variant="subtitle1"
                bgcolor="default-background.main"
                color="light-gray-text.main"
                px={1}
              >
                Active
              </Typography>
            ) : null}
            {initialValues?.advertisement_status === 3 ? (
              <Typography
                variant="subtitle1"
                bgcolor="default-background.main"
                color="light-gray-text.main"
                px={1}
              >
                Inactive
              </Typography>
            ) : null}
          </Box>
          <Box display="flex" alignItems="center" columnGap={2}>
            {/* {  initialValues?.advertisement_status===1 && initialValues?.update_count<2?
          <Typography 
            variant="body1" 
            color="information.main"
            >
            You can only edit this job ads {2-initialValues?.update_count} more time
           </Typography>:null}
          { initialValues?.update_count===2?
          <Typography 
            variant="body1" 
            color="information.main"
            >
            You can no longer edit this job ads
           </Typography>:null} */}

            <AdxButton
              variant={'outlined'} // disabled={initialValues?.update_count===2? true:false}
              size="small"
              sx={{ width: 100 }}
              // onClick={previewAdModal.handleOpen}
              onClick={() => {
                handleSave(formikValues)
              }}
            >
              Save
            </AdxButton>
            <Box display="flex" alignItems="center" columnGap={2}>
              <AdxPopper placement="bottom-start" sx={{ marginTop: 1 }}>
                <Box onClick={handleDrawer('right', true)}>Preview</Box>

                {initialValues?.advertisement_status !== 1 ? (
                  <Box
                    sx={{
                      color: 'error.main',
                    }}
                    onClick={deleteModal.handleOpen}
                  >
                    Delete
                  </Box>
                ) : null}
              </AdxPopper>
            </Box>
          </Box>
        </Box>
      </AdxFullWindowTitleBar>

      {/* Form */}
      <JobAdForm
        isPreviewAd={drawerState}
        handleUpdateJobAds={handleUpdateJobAds}
        handleClosePreview={handleDrawer}
        initialValues={initialValues}
        onSubmit={onSubmit}
        handleTypeOfForm={handleTypeOfForm}
        editJobAds={editJobAds}
        publishJobAds={publishJobAds}
        editIsLoading={editIsLoading}
        draftIsLoading={draftIsLoading}
        handleFormikValues={handleFormikValues}
      />

      <SuccessJobAdsModal />

      {/* loading submit form*/}
      {(createJobPostingPublishisLoading || createJobPostingDraftisLoading) && (
        <LoadingJobAdsModal />
      )}

      {/* close window confirmation */}
      {confirmationModal.isOpen ? <CloseJobAdConfirmationModal /> : null}

      {deleteModal.isOpen ? <DeleteJobAdsModal /> : null}

      {/* successfully delete job ads */}
      {deleteSucess.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="success"
          TransitionComponent="slide"
          message="Job advertisement deleted"
          open={deleteSucess.isOpen}
          handleClose={deleteSucess.handleClose}
        />
      ) : null}

      {/* error delete job ads */}
      {errorSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="error"
          TransitionComponent="slide"
          message="An error has occured. Please try again"
          open={errorSnackbar.isOpen}
          handleClose={errorSnackbar.handleClose}
        />
      ) : null}
    </Box>
  )
}
export default JobAdWindow
